module.exports = __webpack_public_path__ + "static/media/sensor-object-example-photo.2b54cf07.jpg";